// Digest: 15be8185c775c4e160345fefec4ef572ced2611d
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface _Types {
  HomePageProps: ServerTemplatesHomePage;
  LoginPageProps: ServerTemplatesLoginPage;
  NotFound404Props: ServerTemplatesNotFound404;
  InternalServerError500Props: ServerTemplatesInternalServerError500;
  PlaygroundPageProps: ServerTemplatesPlaygroundPage;
  ResearchPageProps: ServerTemplatesResearchPage;
  ProjectsListProps: ServerProjectsTemplatesProjectsList;
  ProjectEditProps: ServerProjectsTemplatesProjectEdit;
  ProjectAddProps: ServerProjectsTemplatesProjectAdd;
  globals: {
    Widget:
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsTextarea
      | DjangoFormsWidgetsSelect
      | TaggitFormsTagWidget
      | DjangoFormsWidgetsClearableFileInput
      | DjangoFormsWidgetsNumberInput
      | DjangoFormsWidgetsDateInput;
    models: {
      "projects.templates._Project_T": ProjectsTemplates_Project_T;
      "projects.templates._Tag_T": ProjectsTemplates_Tag_T;
      "projects.templates._User_T": ProjectsTemplates_User_T;
    };
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ServerSettingsAuthContextProcessor;
  RPCPermission: null;
}
export interface ServerTemplatesHomePage {
  user: AbstractUserB8290416Dc | null;
}
export interface AbstractUserB8290416Dc {
  is_staff: boolean;
}
export interface ServerTemplatesLoginPage {
  user: AbstractUserB8290416Dc | null;
}
export interface ServerTemplatesNotFound404 {
  user: AbstractUserB8290416Dc | null;
}
export interface ServerTemplatesInternalServerError500 {
  user: AbstractUserB8290416Dc | null;
}
export interface ServerTemplatesPlaygroundPage {
  user: AbstractUserB8290416Dc | null;
}
export interface ServerTemplatesResearchPage {
  user: AbstractUserB8290416Dc | null;
}
export interface ServerProjectsTemplatesProjectsList {
  projects: ProjectsTemplates_Project_T[];
  can_edit: ProjectF0Adb9Ca0D[];
  can_add: boolean;
}
export interface ProjectsTemplates_Project_T {
  id: number;
  title: string;
  details: string;
  status: string;
  splash_art: {
    url: string;
  };
  progress: number;
  start_date: string;
  tags: {
    id: number;
    name: string;
  }[];
  contact: {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
  } | null;
}
export interface ProjectF0Adb9Ca0D {
  id: number;
}
export interface ServerProjectsTemplatesProjectEdit {
  project: ProjectsTemplates_Project_T;
  form: ServerProjectsForms;
  available_tags: ProjectsTemplates_Tag_T[];
  available_contacts: ProjectsTemplates_User_T[];
}
export interface ServerProjectsForms {
  name: "server.projects.forms.ProjectForm";
  errors: {
    title?: string[];
    details?: string[];
    status?: string[];
    tags?: string[];
    splash_art?: string[];
    progress?: string[];
    contact?: string[];
    start_date?: string[];
  } | null;
  fields: {
    title: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    details: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
    status: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    tags: ReactivatedSerializationFieldType & {
      widget: TaggitFormsTagWidget;
    } & {};
    splash_art: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsClearableFileInput;
    } & {};
    progress: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsNumberInput;
    } & {};
    contact: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    start_date: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsDateInput;
    } & {};
  };
  prefix: string;
  iterator: ("title" | "details" | "status" | "tags" | "splash_art" | "progress" | "contact" | "start_date")[];
  hidden_fields?: ("title" | "details" | "status" | "tags" | "splash_art" | "progress" | "contact" | "start_date")[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedSerializationWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface TaggitFormsTagWidget {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "taggit.forms.TagWidget";
}
export interface DjangoFormsWidgetsClearableFileInput {
  template_name: "django/forms/widgets/clearable_file_input.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "file";
  checkbox_name: string;
  checkbox_id: string;
  is_initial: boolean;
  input_text: string;
  initial_text: string;
  clear_checkbox_label: string;
  tag: "django.forms.widgets.ClearableFileInput";
}
export interface DjangoFormsWidgetsNumberInput {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsStepAttrs;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedSerializationWidgetsStepAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsDateInput {
  template_name: "django/forms/widgets/date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsDateAttrs;
  type: "text";
  tag: "django.forms.widgets.DateInput";
}
export interface ReactivatedSerializationWidgetsDateAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format?: string;
}
export interface ProjectsTemplates_Tag_T {
  name: string;
}
export interface ProjectsTemplates_User_T {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}
export interface ServerProjectsTemplatesProjectAdd {
  form: ServerProjectsForms;
  available_tags: ProjectsTemplates_Tag_T[];
  available_contacts: ProjectsTemplates_User_T[];
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ServerSettingsAuthContextProcessor {
  user: ServerSettings_AuthContextProcessor_User_T;
}
export interface ServerSettings_AuthContextProcessor_User_T {
  id: number | string | null;
  username: string | null;
  is_staff: boolean;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as HomePageImplementation} from "@client/templates/HomePage"
export type HomePageCheck = Checker<_Types["HomePageProps"], typeof HomePageImplementation>;

export namespace templates {
    export type HomePage = _Types["HomePageProps"];
}


        



import {Template as LoginPageImplementation} from "@client/templates/LoginPage"
export type LoginPageCheck = Checker<_Types["LoginPageProps"], typeof LoginPageImplementation>;

export namespace templates {
    export type LoginPage = _Types["LoginPageProps"];
}


        



import {Template as NotFound404Implementation} from "@client/templates/NotFound404"
export type NotFound404Check = Checker<_Types["NotFound404Props"], typeof NotFound404Implementation>;

export namespace templates {
    export type NotFound404 = _Types["NotFound404Props"];
}


        



import {Template as InternalServerError500Implementation} from "@client/templates/InternalServerError500"
export type InternalServerError500Check = Checker<_Types["InternalServerError500Props"], typeof InternalServerError500Implementation>;

export namespace templates {
    export type InternalServerError500 = _Types["InternalServerError500Props"];
}


        



import {Template as PlaygroundPageImplementation} from "@client/templates/PlaygroundPage"
export type PlaygroundPageCheck = Checker<_Types["PlaygroundPageProps"], typeof PlaygroundPageImplementation>;

export namespace templates {
    export type PlaygroundPage = _Types["PlaygroundPageProps"];
}


        



import {Template as ResearchPageImplementation} from "@client/templates/ResearchPage"
export type ResearchPageCheck = Checker<_Types["ResearchPageProps"], typeof ResearchPageImplementation>;

export namespace templates {
    export type ResearchPage = _Types["ResearchPageProps"];
}


        



import {Template as ProjectsListImplementation} from "@client/templates/ProjectsList"
export type ProjectsListCheck = Checker<_Types["ProjectsListProps"], typeof ProjectsListImplementation>;

export namespace templates {
    export type ProjectsList = _Types["ProjectsListProps"];
}


        



export namespace interfaces {
    export type ProjectEdit = _Types["ProjectEditProps"];
}


        



export namespace interfaces {
    export type ProjectAdd = _Types["ProjectAddProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

